import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Components
import FullPageLayout from '../../components/FullPageLayout';
import LoadingSpinner from '../../components/LoadingSpinner';
import { ResponsiveImage } from 'dabbl-react-components';

// Images
import {DOWNTIMEDOLLARS_LOGO_VERTICAL} from "../../retailerValues";

class LoadingPage extends Component {

  static propTypes = {
    isLoading: PropTypes.bool.isRequired,
  }

  componentDidMount() {
    this.toggleBodyScrollLock();
  }

  shouldComponentUpdate(nextProps, nextState) {
        return (this.props.isLoading !== nextProps.isLoading)
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.isLoading !== this.props.isLoading)
      this.toggleBodyScrollLock();
  }

  toggleBodyScrollLock() {
    let body = document.querySelector('body');

    if (this.props.isLoading) {
      body.style.overflowY = 'hidden';
    } else {
      body.style.overflowY = 'scroll';
    }
  }

  render() {
    const { isLoading } = this.props;

    return (
      <div style={{display: (isLoading) ? 'block' : 'none'}}>
        <FullPageLayout style={{position: 'relative'}}>
          <div className="Loading">
            <div className="fit-to-parent vertical-center" style={{justifyContent: 'center'}}>

              <div>
                <ResponsiveImage
                  className="Loading_logo"
                  src={DOWNTIMEDOLLARS_LOGO_VERTICAL}
                  alt="Downtime Dollars"
                />
              </div>

              <LoadingSpinner />

            </div>
          </div>
        </FullPageLayout>
      </div>
    );
  }
}

export default LoadingPage;



// WEBPACK FOOTER //
// ./src/components/Loading/Loading.js